import Vue from "vue";
//模块功能：产品详情-船舶气象导航服务
export default Vue.extend({
    name: "weather-route",
    data: function () {
        return {
            contList1: {
                list1: ['经济航路', '快捷航路', '舒适航路'],
                list2: ['准班航路', '节能航路', '安全航路'],
            },
            contList2: {
                list1: ['航行状态', '航路气象', '船舶油耗'],
            },
            contList3: {
                list1: ['目的港 /ETA 变更', '航行状态 / 气象变更', '港口动态 / 气象', '预到港 / 靠离港', '进出 ECAs/ 海盗区 ', '特殊事件提醒 '],
                list2: ['航路气象预警', '航速 / 航迹偏离预警 ', 'ETA 偏离预警', '航行安全指标偏离预警', '接近台风影响范围预警', '接近设定特殊区域预警']
            },
            contList4: {
                list1: ['航次事实记录', '航路气象信息记录与统计', '航速 & 油耗索赔报告', '航次评估报告']
            }
        };
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            return this.$t('productsdetail.weatherrouting');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/weather-route.vue
// module id = null
// module chunks = 